export default function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}


//////////////////
// WEBPACK FOOTER
// /Users/maciekbaron/Development/seuk-fe/web/app/themes/seuk/node_modules/swiper/core/loop/loopDestroy.js
// module id = 122
// module chunks = 0